module.exports = __webpack_public_path__ + "static/new-tranquility-logo-ea55d156a47eb6e4c5e676e0f49e89a6.png";